/* ==========================================================================
   Threaded Vision — slot machine SMS pop-up (2026-11-03, Jalen; option 7 of
   clients/threaded_vision/site_rebuild/mockups/sms_popup.html)

   Flow:  trigger (delay / desktop exit intent) -> pull the lever (tap it, drag
          it down, or tap the reels) -> three reels spin through pieces the store
          sells, stop left to right, and land three 10% OFF tiles (EVERY visitor
          gets the same one, never a product) -> "Claim" reveals the Postscript
          pop-up, which collects the phone number and texts the code.

   Postscript hold and lifecycle (once per visitor, cooldown after a dismiss,
   reopen tab, subscriber skip, scroll lock, instant hand-off) are a port of
   fraternal assets/frt-slot-popup.js. The reel engine is the mockup's.
   Config: window.TV_SLOT_CFG, written by snippets/tv-slot-config.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-tv-slot]');
  if (!root || typeof root.showModal !== 'function') return;

  var c0 = window.TV_SLOT_CFG || {};
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  var cfg = {
    enabled:      c0.enabled === true,
    popupId:      String(c0.popupId || '').trim(),
    delay:        num(c0.delay, 6),
    exitIntent:   c0.exitIntent === true,
    cooldownDays: num(c0.cooldownDays, 7),
    force:        /[?&]tv_slot=1\b/.test(location.search)
  };
  var ready = cfg.enabled && !!cfg.popupId;

  var KEY = 'tv_slot_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('tv:slot-popup', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */
  function fromOurTexts() { return /utm_source=postscript/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // getSubscriberId may be sync or a promise depending on the SDK build.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } }, function () { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else cb(!!r);
  }

  /* ------------------------------------------------------- Postscript hold
     html.tv-ps-hold (set in <head> by snippets/tv-slot-hold.liquid) keeps Postscript's frame invisible and
     click-through while unclaimed. Once the reels land we open OUR configured pop-up ourselves, still hidden, so it
     is fully drawn before Claim; Claim reveals it. */
  var holding = document.documentElement.classList.contains('tv-ps-hold');
  function holdPostscript() { if (!holding) { holding = true; document.documentElement.classList.add('tv-ps-hold'); } }
  function releaseHold() { holding = false; document.documentElement.classList.remove('tv-ps-hold'); }
  var preopened = false;
  function psOpen() {
    var ps = window.postscript;
    if (!cfg.popupId || !ps || !ps.popups || typeof ps.popups.open !== 'function') return false;
    // Options as in Postscript's own snippet for this pop-up (Jalen, 2026-11-03).
    try { ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: true }); return true; } catch (e) { return false; }
  }
  function preopenPostscript() { if (holding && !preopened && psOpen()) preopened = true; }

  // Never stack on the bag, menu, search, size sheet or another dialog.
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    if (document.querySelector('[data-tv-drawer]:not([hidden])')) return true;
    if (document.querySelector('[aria-expanded="true"][aria-controls]')) return true;
    var ps = document.getElementById('ps__widget');
    if (ps && !holding) { var r = ps.getBoundingClientRect(); if (r.width > 200 && r.height > 200 && getComputedStyle(ps).visibility !== 'hidden') return true; }
    return false;
  }

  var shown = false, timer = null;
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if ((ready || cfg.force) && cfg.popupId && !s.claimed && !fromOurTexts()) holdPostscript();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */
  var machine = root.querySelector('[data-slot-machine]');
  var winEl   = root.querySelector('[data-slot-win]');
  var lever   = root.querySelector('[data-slot-lever]');
  var ledEl   = root.querySelector('[data-slot-led]');
  var bulbsEl = root.querySelector('[data-slot-bulbs]');
  var claimEl = root.querySelector('[data-slot-claim]');
  var live    = root.querySelector('[data-slot-live]');
  var won = false, claimed = false, spinning = false;
  var keyboardUser = false;
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);
  function setState(s) { root.setAttribute('data-slot-state', s); }

  /* --------------------------------------------- lazy images + fonts (once) */
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    var imgs = root.querySelectorAll('img[data-slot-src]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].src = imgs[i].getAttribute('data-slot-src'); imgs[i].removeAttribute('data-slot-src'); }
    var f = document.createElement('link');
    f.rel = 'stylesheet';
    f.href = 'https://fonts.googleapis.com/css2?family=Archivo:wght@500;600;800;900&family=Archivo+Narrow:wght@700&family=IBM+Plex+Mono:wght@500&display=swap';
    document.head.appendChild(f);
  }

  /* ------------------------------------------------------------------ reels
     Each reel's strip is rendered once by Liquid (the store's pieces + one 10% OFF tile, [data-slot-hit]); here it
     is doubled so it can wrap, and positioned by a pixel offset. Measured only while the dialog is open. */
  var reels = null;
  function setupReels() {
    if (reels) return;
    reels = [].map.call(root.querySelectorAll('[data-slot-strip]'), function (strip) {
      var cells = [].slice.call(strip.children), n = cells.length, hit = 0;
      for (var i = 0; i < n; i++) if (cells[i].hasAttribute('data-slot-hit')) hit = i;
      cells.forEach(function (c) { var d = c.cloneNode(true); d.setAttribute('aria-hidden', 'true'); strip.appendChild(d); });
      return { el: strip.closest('.tv-slot__reel'), strip: strip, n: n, hit: hit, o: 0 };
    });
    reels.forEach(function (r) { show(r, centerOf(r, (r.hit + 2) % r.n)); });   // opening line: three pieces, never 10%
  }
  function cellH(r) { return r.strip.firstElementChild.offsetHeight || 74; }
  function centerOf(r, i) { return i * cellH(r) - (r.el.clientHeight - cellH(r)) / 2; }
  function show(r, o) { var L = r.n * cellH(r); r.o = o; r.strip.style.transform = 'translateY(' + (-(((o % L) + L) % L)).toFixed(1) + 'px)'; }
  function landAll() { reels.forEach(function (r) { show(r, centerOf(r, r.hit)); }); }

  /* marquee bulbs evenly around the cabinet; alternate ones chase */
  function lightUp() {
    if (!machine.offsetWidth) return;
    var W = machine.offsetWidth, H = machine.offsetHeight, e = 7, gap = 17, html = '';
    function run(x0, y0, x1, y1) {
      var n = Math.max(1, Math.round(Math.hypot(x1 - x0, y1 - y0) / gap));
      for (var k = 0; k < n; k++) html += '<i class="tv-slot__bulb" style="left:' + (x0 + (x1 - x0) * k / n).toFixed(1) + 'px;top:' + (y0 + (y1 - y0) * k / n).toFixed(1) + 'px"></i>';
    }
    run(18, e, W - 18, e); run(W - e, 18, W - e, H - 18); run(W - 18, H - e, 18, H - e); run(e, H - 18, e, 18);
    bulbsEl.innerHTML = html;
  }
  window.addEventListener('resize', function () { if (root.open) lightUp(); });

  /* ------------------------------------------------------ scroll lock (html) */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('tv-slot-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('tv-slot-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  function open() {
    if (root.open) return;
    shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    var s = readState();
    if (s.won && !won) won = true;
    setState(won ? 'won' : 'ready');
    root.showModal(); lockScroll();
    setupReels(); if (won) landAll(); lightUp();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (root.open) lightUp(); });
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    if (won) preopenPostscript();
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target === root) root.close();                           // backdrop
    if (e.target.closest('[data-slot-close]')) root.close();
  });

  /* ------------------------------------------------------------------ pull
     No skill: every pull lands three 10% OFF tiles. Reels stop left to right, the last one slower. */
  function spin() {
    spinning = true; root.classList.add('is-spinning'); ledEl.textContent = "DON'T BLINK";
    emit('start');
    var plan = [{ ms: 1500, loops: 3, k: 3 }, { ms: 2100, loops: 4, k: 3 }, { ms: 3300, loops: 5, k: 4 }];
    if (reduceMotion) plan.forEach(function (p) { p.ms = 1; });
    var t0 = performance.now(), left = reels.length;
    reels.forEach(function (r, i) {
      var P = plan[Math.min(i, plan.length - 1)], L = r.n * cellH(r), to = centerOf(r, r.hit);
      var from = r.o, D = P.loops * L + (((from - to) % L) + L) % L;
      (function frame(now) {
        var p = Math.min(1, Math.max(0, now - t0) / P.ms);
        show(r, from - D * (1 - Math.pow(1 - p, P.k)));
        r.el.classList.toggle('is-blur', p < .72);
        if (p < 1) return requestAnimationFrame(frame);
        r.el.classList.add('is-stop'); if (!reduceMotion && navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} }
        left--;
        if (left === 1) { root.classList.add('is-tease'); ledEl.textContent = 'ONE MORE'; }
        if (left === 0) { spinning = false; root.classList.remove('is-spinning', 'is-tease'); finish(); }
      })(t0);
    });
  }
  function pull() {
    if (won || spinning || !root.open) return;
    lever.classList.remove('is-nudge', 'is-back', 'is-grab'); lever.classList.add('is-down'); lever.style.setProperty('--p', 1);
    spinning = true;
    setTimeout(function () { lever.classList.remove('is-down'); lever.classList.add('is-back'); lever.style.setProperty('--p', 0); spin(); }, 170);
  }
  var y0 = null, moved = 0;
  lever.addEventListener('pointerdown', function (e) {
    if (won || spinning) return; e.preventDefault(); y0 = e.clientY; moved = 0;
    try { lever.setPointerCapture(e.pointerId); } catch (err) {}
    lever.classList.remove('is-nudge', 'is-back'); lever.classList.add('is-grab');
  });
  lever.addEventListener('pointermove', function (e) {
    if (y0 === null) return; moved = e.clientY - y0;
    lever.style.setProperty('--p', Math.max(0, Math.min(1, moved / 70)).toFixed(3));
  });
  function release() {
    if (y0 === null) return; y0 = null; lever.classList.remove('is-grab');
    if (moved > 38 || Math.abs(moved) < 6) pull(); else { lever.classList.add('is-back'); lever.style.setProperty('--p', 0); }
  }
  lever.addEventListener('pointerup', release); lever.addEventListener('pointercancel', release);
  winEl.addEventListener('click', pull);
  winEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pull(); } });

  function finish() {
    if (won) return;
    won = true;
    setState('won'); lightUp();
    if (!reduceMotion && navigator.vibrate) { try { navigator.vibrate([40, 30, 80]); } catch (e) {} }
    writeState({ won: Date.now() });
    if (live) live.textContent = 'Three in a row. 10% off your first order is yours. We text you the code.';
    emit('reveal');
    preopenPostscript();
    if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true });
  }

  /* ----------------------------------------------------------------- claim
     Postscript's SDK can take several seconds to start, and an open() made before it has its pop-up list is
     silently dropped. So Claim keeps the card up ("Opening…"), re-asks Postscript every 2 s, and steps aside only
     once Postscript's frame is actually drawn (still hidden by the hold, but sized). After 10 s with nothing, the
     card stays up and asks them to tap again. */
  var CLAIM_WAIT = 10000, RETRY_EVERY = 2000;
  function postscriptShowing() {
    var fs = document.querySelectorAll('iframe[src*="postscript.io"]'), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < fs.length; i++) {
      var r = fs[i].getBoundingClientRect();
      if (r.width > vw * 0.5 && r.height > vh * 0.5) return true;
    }
    return false;
  }
  function revealPostscript() {
    claimed = true;
    writeState({ claimed: Date.now() });
    hideTab();
    releaseHold(); root.close(); root.classList.remove('is-claiming');
  }
  claimEl.addEventListener('click', function (e) {
    e.preventDefault();
    if (root.classList.contains('is-claiming')) return;
    var note = root.querySelector('[data-slot-setup-note]'); if (note) note.hidden = true;
    root.classList.add('is-claiming');
    emit('claim', { via: preopened ? 'postscript-preopened' : 'postscript-popup' });
    var t0 = Date.now(), lastAsk = 0;
    if (!preopened && psOpen()) { preopened = true; lastAsk = t0; }
    (function check() {
      if (!root.open) return;
      if (postscriptShowing()) return revealPostscript();
      var now = Date.now();
      if (now - t0 > CLAIM_WAIT) {                                 // never close onto nothing: keep the card, ask again
        root.classList.remove('is-claiming');
        if (note) note.hidden = false;
        emit('claim-failed');
        return;
      }
      if (now - lastAsk > RETRY_EVERY && psOpen()) { preopened = true; lastAsk = now; }
      requestAnimationFrame(check);
    })();
  });

  /* ------------------------------------------------- reopen tab (bottom left) */
  var tab = document.querySelector('[data-slot-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-slot-won', (won || readState().won) ? 'true' : 'false');
    function reveal() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return reveal();
    isSubscriber(function (sub) { if (!sub) reveal(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-slot-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-slot-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    window.addEventListener('postscriptReady', function () { isSubscriber(function (sub) { if (sub) hideTab(); }); });
    // Never sit on a button: tuck off the edge while overlapping a buy button, the PDP sticky bar, or a way to pay.
    var BUY = '.tv-btn, .tv-sticky, .btn, form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], ' +
              '.shopify-payment-button, shopify-accelerated-checkout, [name="checkout"]';
    var tq = false;
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function tuck() {
      tq = false; if (tab.hidden) return;
      var l = tab.offsetLeft, t = tab.offsetTop, pad = { left: l - 10, right: l + tab.offsetWidth + 10, top: t - 10, bottom: t + tab.offsetHeight + 10 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) {
        var b = els[i].getBoundingClientRect();
        if (b.width && b.height && getComputedStyle(els[i]).visibility !== 'hidden' && overlaps(pad, b)) hit = true;
      }
      tab.classList.toggle('is-tucked', hit);
    }
    function queueTuck() { if (!tq) { tq = true; requestAnimationFrame(tuck); } }
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  // QA: ?tv_slot=1 forces it open from a fresh start (even while switched off); TV_SLOT.reset() clears the visitor memory.
  window.TV_SLOT = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  arm();
})();
